import { Directive, HostListener, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppComponentBase } from '../app-component-base';

@Directive({
  selector: '[startPhoneFive]'
})
export class StartPhoneFiveDirective extends AppComponentBase {

  constructor(
    injector: Injector,
    private ngControl: NgControl,
    private _ToastrService: ToastrService
  ) {
    super(injector)
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent | any) {
    const currentValue: string = this.ngControl.value;
    const keyPressed: string = event.key;

    if (currentValue == '' && keyPressed != '5') {
      event.preventDefault();
      this._ToastrService.error( this.isDirRTL ? 'يجب أن يبدأ رقم الهاتف بالرقم 5 بدون رمز الدولة' : 'The phone number must start with 5 without the country code.' )
    }
  }

}
